import { addHours, format, parseISO } from 'date-fns';
import { extractTimeAndDate } from '../../lib/util/dateConvert';
import { convertToTimezoneAndGroup } from '../../lib/util/getDayName';

function convertToTimezone(date: Date, timezoneOffset: number): Date {
  return addHours(date, timezoneOffset);
}

export function convert(
  dateArray: string[],
  dateWeekendArray: string[],
  timezone: number,
): { date: string; oldDate: string[]; time: string[]; isWeekend: boolean }[] {
  const resultMap = new Map<
    string,
    { oldDate: string[]; time: string[]; day: string }
  >();

  const convertedDateArr = dateArray.map((dateString) => {
    const date = parseISO(dateString.replace('Z', ''));
    const localizedDate = addHours(date, timezone);

    const label = format(localizedDate, "yyyy-MM-dd'T'HH:mm:ss");

    return { label, value: dateString };
  });

  const dateWeekend =
    dateWeekendArray && dateWeekendArray.length > 0
      ? dateWeekendArray.map((date) => ({ value: date, label: date }))
      : [];

  const dayArr = [...convertedDateArr, ...dateWeekend];

  dayArr.forEach((dateString) => {
    const dateObj = extractTimeAndDate(dateString.label);

    const existingEntry = resultMap.get(dateObj.date) || {
      oldDate: [],
      time: [],
      day: '',
    };

    existingEntry.time.push(dateObj.time);
    existingEntry.oldDate.push(dateString.value);
    existingEntry.day = dateObj.day;

    sortEntry(existingEntry);

    resultMap.set(dateObj.date, existingEntry);
  });

  return Array.from(resultMap.entries()).map(
    ([date, { oldDate, time, day }]) => ({
      date,
      oldDate,
      time,
      day,
      isWeekend: Array.isArray(dateWeekendArray)
        ? dateWeekendArray?.some((weekendDate) => weekendDate.startsWith(day))
        : false,
    }),
  );
}

function sortEntry(entry: { oldDate: string[]; time: string[] }) {
  const combined = entry.time.map((timeValue, index) => ({
    time: timeValue,
    oldDate: entry.oldDate[index],
  }));

  combined.sort((a, b) => {
    const [aHour, aMinute] = a.time.split(':').map(Number);
    const [bHour, bMinute] = b.time.split(':').map(Number);
    return aHour === bHour ? aMinute - bMinute : aHour - bHour;
  });

  entry.time = combined.map((item) => item.time);
  entry.oldDate = combined.map((item) => item.oldDate);
}
